import React from 'react'
import "./ListFilter.css"
import { useDispatch } from 'react-redux';
import { filterActions } from '../../../../store/filter-slice';
import { MenuItem, TextField } from '@mui/material';


const Status = ({campaigns, status, setStatus}) => {
  // const dispatch=useDispatch();
    // function handleSelectChange(event){
    //   // dispatch(filterActions.selectedStatus(event.target.value))

    // }

  return (
    <div className='status'>
        <p className='f-name'>Status:</p>
        <TextField sx={{minWidth: "10rem"}} value={status}  select  onChange={(e, newVal) => setStatus(e.target.value) } >
      
          <MenuItem value="ALL_STATUS">All Status</MenuItem>
                <MenuItem value="LIVE_CAMPAIGNS">Live Now</MenuItem>
                <MenuItem value="STOPPED_CAMPAIGNS">Paused</MenuItem>
                <MenuItem value="COMPLETED_CAMPAIGNS">Completed</MenuItem>
                <MenuItem value="AWAITING_APPROVAL">Pending</MenuItem>
        </TextField>

    </div>
  )
}

export default Status